import React from "react";
import { metricsData, performanceTable } from "./DashboardConfig";
import TargetAchievedChart from "./TargetAchievedChart";
import PerformanceTable from "./PerformanceTable";

const DashboardSection: React.FC = () => {
  return (
    <div className="w-full grid grid-cols-1 lg:grid-cols-12 gap-6 mt-6 auto-rows-fr">

      {/* Left Component */}
      <div className="lg:col-span-5 h-full ">
        <div className="h-full">
          <TargetAchievedChart data={metricsData} />
        </div>
      </div>

      {/* Right Component */}
      <div className="lg:col-span-7 h-full">
        <div className="h-full">
          <PerformanceTable data={performanceTable} />
        </div>
      </div>

    </div>
  );
};

export default DashboardSection;
